import type { FallbackProps, ServerSideProps } from '@gik/core/api/BaseAPIConfig';
import { ISRRevalidateTimeout, baseFallback } from '@gik/core/api/BaseAPIConfig';
import { catchSSRError } from '@gik/core/utils/catchSSRError';
import { measureSSRPerformance } from '@gik/core/utils/measureSSRPerformance';
import type { InkindGroupPageServerProps } from '@gik/inkind-group/components/InkindGroupPage.tsx';
import { InkindGroupPage } from '@gik/inkind-group/components/InkindGroupPage.tsx';
import { getGroup } from '@/api/groups/group';
import type { PageLayoutProps } from '@/components/layout/PageLayout';
import { PageLayout } from '@/components/layout/PageLayout';
import type { GetServerSidePropsContext } from 'next';
import { useRouter } from 'next/router';
import { SWRConfig } from 'swr';

export default function InkindGroupPageWrapper({ fallback }: FallbackProps<InkindGroupPageServerProps>) {
  const router = useRouter();
  if (router.isFallback) {
    // TODO: wrap each page with withFallback function
    return <div>Loading...</div>;
  }

  const slug = router.query?.slug as string;

  return (
    <SWRConfig value={{ fallback }}>
      <InkindGroupPage groupSlug={slug} />
    </SWRConfig>
  );
}

InkindGroupPageWrapper.getLayout = function getLayout(page, layoutProps: PageLayoutProps) {
  return (
    <PageLayout {...layoutProps} key={layoutProps.key}>
      {page}
    </PageLayout>
  );
};

async function _getStaticProps(
  context: GetServerSidePropsContext
): Promise<ServerSideProps<InkindGroupPageServerProps>> {
  const slug = context.params?.slug as string;

  const group = getGroup(slug);

  // FIXME: this should be using algolia
  /*const inkinds = group
    ? await dotnetApi
        .get('inkinds', {
          searchParams: {
            page: 8,
            per_page: 8,
            groupId: group?.id,
          },
        })
        .json<InkindPageAPIModel[]>()
    : null;*/

  // @ts-ignore
  return baseFallback(
    {
      [group.key]: await group.json,
    },
    undefined,
    ISRRevalidateTimeout.extraSlow
  );
}

export const getStaticProps = catchSSRError(measureSSRPerformance(_getStaticProps));

export async function getStaticPaths() {
  const paths = [];
  // if (process.env.RENDER_STATIC_PAGES_AT_BUILD_TIME === 'true') {
  //   const groups = await getGroupSlugs();
  //   paths = groups.map(group => ({
  //     params: { slug: group.slug },
  //   }));
  // }

  return { paths, fallback: 'blocking' };
}
